var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNigerian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.75H15.75V20.25H8.25V3.75Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.75C1.26488 3.75 0 5.59688 0 7.875V16.125C0 18.4031 1.26488 20.25 3.75 20.25H8.25V3.75H3.75ZM20.25 3.75H15.75V20.25H20.25C22.7351 20.25 24 18.4031 24 16.125V7.875C24 5.59688 22.7351 3.75 20.25 3.75Z",
    fill: "#128807"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigerian);
export default __webpack_public_path__ + "static/media/nigerian.e7dbc37d27d18eb8101ae9c5894b829b.svg";
export { ForwardRef as ReactComponent };